import { forwardRef } from 'react';

import { IconGradient } from '@xemplo/icons';

import { HeaderIconProps } from '../common';

import * as S from './modal-header-icon.styles';
import { useModalHeaderIcon } from './use-modal-header-icon';

export const ModalHeaderIcon = forwardRef<HTMLDivElement, HeaderIconProps>(
  ({ icon, mode, size }, ref) => {
    const { iconNode, sizeClassName } = useModalHeaderIcon({ icon, size });

    return (
      <S.StyledIconContainer
        ref={ref}
        className={`header-icon-container ${sizeClassName}`.trim()}
      >
        <S.StyledHeaderIconWrapper
          data-mode={mode}
          className={`header-icon ${sizeClassName}`.trim()}
        >
          {iconNode}
        </S.StyledHeaderIconWrapper>
        <IconGradient />
      </S.StyledIconContainer>
    );
  },
);
